import { useState } from 'react';

export const namePattern =
  /^[a-zA-Z0-9\s\-'`àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆŠŽ∂ð]*$/;

export const PASSWORD_MIN_LENGTH = 8;

export function isNumeric(testValue) {
  return !isNaN(testValue) && !/\s+/.test(testValue);
}

const toFieldKey = (name) => (Array.isArray(name) ? name.join('.') : name);

/**
 * AntD fields validate on blur until they first show an error, then on every
 * change too, so the error clears as soon as the value is fixed. Errors are
 * tracked through the form's onFieldsChange, the one place that sees blur,
 * submit and manually set errors alike. Give a rule `validateTrigger: []` to
 * run it on submit only, so tabbing past an empty field doesn't show
 * "required".
 */
export function useBlurChangeValidation(form) {
  const [changeValidatedFields, setChangeValidatedFields] = useState([]);

  const addChangeValidation = (names) => {
    setChangeValidatedFields((current) => {
      const added = names.filter((name) => !current.includes(name));
      return added.length ? [...current, ...added] : current;
    });
  };

  const handleFieldsChange = (changedFields) => {
    addChangeValidation(
      changedFields
        .filter(({ errors }) => errors?.length)
        .map(({ name }) => toFieldKey(name))
    );
  };

  const setFieldError = (name, message) => {
    form.setFields([{ name, errors: [message] }]);
    addChangeValidation([name]);
  };

  const validateTriggerFor = (name) =>
    changeValidatedFields.includes(name) ? ['onBlur', 'onChange'] : 'onBlur';

  return { handleFieldsChange, setFieldError, validateTriggerFor };
}
